/* DEMO product page (29 Oct, v5): title block, summary, price + stock tag, ONE quantity box (grey end caps for - and +, white middle; any other +/- the theme adds is hidden), one gallery (arrows, thumbnails, hover zoom, click to enlarge, SKU line), and a BUY NOW bar that stays on screen. Undo = delete this file, dc-product.css and their lines in snippets/oldIE-js.liquid. */
(function () {
  'use strict';
  var imgs = document.getElementById('product-images');
  var det = document.getElementById('product-details');
  if (!imgs || !det) return;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h) e.innerHTML = h; return e; }
  var px = null;

  try {
    var h1 = $('#product-title', det);
    if (h1 && !$('.dc-head', det)) {
      var head = el('div', 'dc-head');
      var logo = h1.previousElementSibling;
      var stars = $('.feefo-product-stars-widget', det);
      det.insertBefore(head, det.firstChild);
      if (logo && logo.tagName === 'A' && $('img', logo)) { logo.className += ' dc-logo'; head.appendChild(logo); }
      head.appendChild(h1);
      if (stars) head.appendChild(stars);
    }
  } catch (e) {}

  try {
    var dsc = $('#product-description');
    if (dsc && !$('.dc-sum', det)) {
      var txt = '';
      $$('p', dsc).some(function (p) { var t = (p.textContent || '').replace(/\s+/g, ' ').trim(); if (t.length >= 40) { txt = t; return true; } return false; });
      if (txt) {
        if (txt.length > 200) { var cut = txt.slice(0, 200), dot = Math.max(cut.lastIndexOf('. '), cut.lastIndexOf('! ')); txt = dot > 60 ? cut.slice(0, dot + 1) : cut.slice(0, cut.lastIndexOf(' ')) + '…'; }
        var sm = el('div', 'dc-sum'); sm.textContent = txt;
        var hd = $('.dc-head', det); if (hd && hd.nextSibling) det.insertBefore(sm, hd.nextSibling); else det.appendChild(sm);
      }
    }
  } catch (e) {}

  try {
    var prices = $('.product-single__prices', det), form = $('#AddToCartForm', det);
    if (prices && form && !$('.dc-buy', det)) {
      var buy = el('div', 'dc-buy');
      prices.parentNode.insertBefore(buy, prices);
      buy.appendChild(prices); buy.appendChild(form);
    }
    var q = $('#product-quantity-input'), qb = $('#product-quantity');
    if (q && qb && !$('.dc-qbox', qb)) {
      var qbox = el('div', 'dc-qbox', '<button type="button" class="dc-step" aria-label="One fewer">&minus;</button><input type="text" inputmode="numeric" maxlength="2" aria-label="Quantity"><button type="button" class="dc-step" aria-label="One more">+</button>');
      qb.appendChild(qbox);
      px = $('input', qbox); px.value = q.value || 1;
      var setQ = function (v) { v = Math.max(1, Math.min(99, parseInt(v, 10) || 1)); q.value = v; px.value = v; q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); };
      var sbq = $$('.dc-step', qbox);
      sbq[0].addEventListener('click', function () { setQ((parseInt(q.value, 10) || 1) - 1); });
      sbq[1].addEventListener('click', function () { setQ((parseInt(q.value, 10) || 1) + 1); });
      px.addEventListener('change', function () { setQ(px.value); });
    }
  } catch (e) {}

  /* quantity look: white box with grey end caps for - and +; hide any other +/- the theme adds near the quantity */
  try {
    var css = document.createElement('style');
    css.textContent = '#product-details .dc-buy #product-quantity,#product-details .dc-buy #product-quantity.is-hidden{background:#fff!important;border:1px solid #d9d2c7!important;box-sizing:border-box}' +
      '#product-details .dc-qbox{height:100%!important;align-items:stretch!important}' +
      '#product-details .dc-qbox .dc-step{background:#e9e5df!important;color:#6f675d!important;border:0!important;box-shadow:none!important;border-radius:0!important;text-shadow:none!important;height:100%!important;width:44px!important}' +
      '#product-details .dc-qbox .dc-step:hover{background:#ddd7cd!important}' +
      '#product-details .dc-qbox input{height:100%!important;border-radius:0!important;background:#fff!important}' +
      '.dc-bar .dc-bar-q{background:#fff!important;border:1px solid #d9d2c7!important;box-sizing:border-box}' +
      '.dc-bar .dc-bar-q .dc-step{background:#e9e5df!important;color:#6f675d!important;border-radius:0!important;height:100%!important}' +
      '.dc-bar .dc-bar-q .dc-step:hover{background:#ddd7cd!important}' +
      '.dc-bar .dc-bar-q input{height:100%!important;border-radius:0!important}' +
      '.dc-hideold{display:none!important}';
    document.head.appendChild(css);
    var kill = function () {
      $$('#product-quantity *, .product-quantity-col *').forEach(function (n) {
        if (n.closest('.dc-qbox') || n.closest('#add-to-cart') || n.id === 'add-to-cart' || n.id === 'dispatch-time-message' || n.closest('#dispatch-time-message')) return;
        var t = (n.textContent || '').replace(/\s+/g, ''), cn = typeof n.className === 'string' ? n.className : '';
        if (n.tagName === 'INPUT' || n.querySelector('input')) return;
        if (/^[+\-−–]$/.test(t) || /(plus|minus|qty|increase|decrease|spinner|stepper)/i.test(cn)) n.classList.add('dc-hideold');
      });
    };
    kill(); setTimeout(kill, 800); setTimeout(kill, 2500); setTimeout(kill, 6000);
    var kt = null, kc = $('.product-quantity-col');
    if (kc) new MutationObserver(function () { clearTimeout(kt); kt = setTimeout(kill, 50); }).observe(kc, { childList: true, subtree: true });
  } catch (e) {}

  try {
    var pr2 = $('.product-single__prices', det), mb = $('#add-to-cart');
    if (pr2 && mb && !$('.dc-stock', pr2)) {
      var chip = el('span', 'dc-stock');
      pr2.appendChild(chip);
      var st = function () { var off = mb.disabled || mb.classList.contains('disabled'); chip.className = 'dc-stock' + (off ? ' dc-out' : ''); chip.innerHTML = '<i></i>' + (off ? 'Sold out' : 'In stock'); };
      st();
      new MutationObserver(st).observe(mb, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
  } catch (e) {}

  var media = $$('.product-single__media', imgs);
  var gal, stage, thumbs, counter, cur = 0, items = [];
  function hi(src) { return src ? src.replace(/([?&])height=\d+&?/, '$1').replace(/([?&])width=\d+/, '$1width=2400').replace(/[?&]$/, '') : src; }
  if (media.length) try {
    gal = el('div', 'dc-gal'); stage = el('div', 'dc-stage');
    imgs.insertBefore(gal, imgs.firstChild);
    gal.appendChild(stage);
    media.forEach(function (m, i) {
      var isImg = !!$('img', m) && !$('video,iframe,model-viewer', m);
      var th = $('.thumbnails-wrapper a[data-thumbnail-id="' + m.id + '"] img', imgs);
      items.push({ m: m, isImg: isImg, thumb: th ? th.getAttribute('src') : ($('img', m) ? $('img', m).getAttribute('src') : '') });
      m.className += ' dc-slide'; stage.appendChild(m);
    });
    var old = $('.thumbnails-wrapper', imgs); if (old) old.className += ' dc-oldthumbs';
    if (items.length > 1) {
      var prev = el('button', 'dc-nav dc-prev', '&#8249;'), next = el('button', 'dc-nav dc-next', '&#8250;');
      prev.type = next.type = 'button'; prev.setAttribute('aria-label', 'Previous picture'); next.setAttribute('aria-label', 'Next picture');
      stage.appendChild(prev); stage.appendChild(next);
      prev.addEventListener('click', function () { go(cur - 1); }); next.addEventListener('click', function () { go(cur + 1); });
      counter = el('span', 'dc-gcount'); stage.appendChild(counter);
      thumbs = el('div', 'dc-thumbs'); gal.appendChild(thumbs);
      items.forEach(function (it, i) {
        var b = el('button', 'dc-th' + (it.isImg ? '' : ' dc-vid'));
        b.type = 'button'; b.setAttribute('aria-label', (it.isImg ? 'Show picture ' : 'Play video ') + (i + 1));
        b.innerHTML = '<img alt="" src="' + it.thumb + '">';
        b.addEventListener('click', function () { go(i); });
        thumbs.appendChild(b);
      });
    }
    var hint = el('span', 'dc-hint', ''); stage.appendChild(hint);
    var hover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
    hint.textContent = hover ? 'Hover to zoom · click to enlarge' : 'Tap to enlarge';
    function go(i) {
      cur = (i + items.length) % items.length;
      items.forEach(function (it, k) { it.m.classList.toggle('dc-on', k === cur); var im = $('img', it.m); if (im) im.style.transform = ''; });
      if (thumbs) $$('.dc-th', thumbs).forEach(function (b, k) { b.classList.toggle('dc-curth', k === cur); if (k === cur) { try { thumbs.scrollTo({ left: b.offsetLeft - 40, behavior: 'smooth' }); } catch (e) {} } });
      if (counter) counter.textContent = (cur + 1) + ' / ' + items.length;
      stage.classList.toggle('dc-isvid', !items[cur].isImg);
    }
    go(0);
    function bigger(im) { if (im && !im.getAttribute('data-hi')) { im.setAttribute('data-hi', '1'); var h = hi(im.getAttribute('src')); if (h && h !== im.getAttribute('src')) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = h; } } }
    stage.addEventListener('mousemove', function (e) {
      if (!hover || !items[cur].isImg || e.target.closest('.dc-nav')) return;
      var im = $('img', items[cur].m); if (!im) return; bigger(im);
      var r = stage.getBoundingClientRect();
      im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      im.style.transform = 'scale(2.2)'; stage.classList.add('dc-zooming');
    });
    stage.addEventListener('mouseleave', function () { var im = $('img', items[cur].m); if (im) im.style.transform = ''; stage.classList.remove('dc-zooming'); });
    var sx = null, sy = 0;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5 && items.length > 1) { go(cur + (dx < 0 ? 1 : -1)); stage.setAttribute('data-sw', '1'); setTimeout(function () { stage.removeAttribute('data-sw'); }, 350); }
    }, { passive: true });
    stage.addEventListener('click', function (e) {
      if (e.target.closest('.dc-nav') || stage.getAttribute('data-sw') || !items[cur].isImg) return;
      openLB();
    });
    var sel = $('#productSelect');
    if (sel) {
      var sk = el('div', 'dc-sku'); gal.appendChild(sk);
      var ssku = function () { var o = sel.options[sel.selectedIndex], s = o && o.getAttribute('data-sku'); sk.textContent = s ? 'SKU: ' + s : ''; sk.style.display = s ? '' : 'none'; };
      ssku(); sel.addEventListener('change', ssku);
    }
  } catch (e) { if (window.console) console.warn('dc-product gallery', e); }

  var lb;
  function openLB() {
    var list = items.map(function (it, i) { return { i: i, src: it.isImg ? hi($('img', it.m).getAttribute('src')) : null }; }).filter(function (x) { return x.src; });
    if (!list.length) return;
    var pos = 0; list.forEach(function (x, k) { if (x.i === cur) pos = k; });
    lb = el('div', 'dc-lb');
    lb.innerHTML = '<button type="button" class="dc-lb-x" aria-label="Close">&times;</button><div class="dc-lb-s"><img alt=""></div><span class="dc-lb-c"></span><span class="dc-lb-h">Click the picture to zoom in or out</span>';
    if (list.length > 1) lb.insertAdjacentHTML('beforeend', '<button type="button" class="dc-nav dc-prev" aria-label="Previous">&#8249;</button><button type="button" class="dc-nav dc-next" aria-label="Next">&#8250;</button>');
    document.body.appendChild(lb); document.documentElement.classList.add('dc-lb-open');
    var im = $('.dc-lb-s img', lb), sc = $('.dc-lb-s', lb), c = $('.dc-lb-c', lb);
    function show(k) { pos = (k + list.length) % list.length; im.src = list[pos].src; lb.classList.remove('dc-z'); sc.scrollTop = sc.scrollLeft = 0; c.textContent = list.length > 1 ? (pos + 1) + ' / ' + list.length : ''; }
    function close() { document.removeEventListener('keydown', key); document.documentElement.classList.remove('dc-lb-open'); if (lb && lb.parentNode) lb.parentNode.removeChild(lb); lb = null; if (items.length) go(list[pos].i); }
    function key(e) { if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight' && list.length > 1) show(pos + 1); else if (e.key === 'ArrowLeft' && list.length > 1) show(pos - 1); }
    document.addEventListener('keydown', key);
    $('.dc-lb-x', lb).addEventListener('click', close);
    var p = $('.dc-prev', lb), n = $('.dc-next', lb);
    if (p) { p.addEventListener('click', function () { show(pos - 1); }); n.addEventListener('click', function () { show(pos + 1); }); }
    sc.addEventListener('click', function (e) {
      if (e.target === sc) { close(); return; }
      var z = lb.classList.toggle('dc-z');
      if (z) { var r = im.getBoundingClientRect(); requestAnimationFrame(function () { sc.scrollLeft = (sc.scrollWidth - sc.clientWidth) * ((e.clientX - r.left) / r.width); sc.scrollTop = (sc.scrollHeight - sc.clientHeight) * ((e.clientY - r.top) / r.height); }); }
    });
    show(pos);
  }

  try {
    var main = $('#add-to-cart'), qty = $('#product-quantity-input');
    if (main && 'IntersectionObserver' in window) {
      var th0 = $('img', $('.dc-slide', imgs) || imgs);
      var bar = el('div', 'dc-bar');
      bar.innerHTML = '<div class="dc-bar-in"><img class="dc-bar-i" alt="" src="' + (th0 ? th0.getAttribute('src') : '') + '"><div class="dc-bar-t"><b></b><span></span></div>' +
        '<div class="dc-bar-q"><button type="button" class="dc-step" aria-label="One fewer">&minus;</button><input type="text" inputmode="numeric" value="1" maxlength="2" aria-label="Quantity"><button type="button" class="dc-step" aria-label="One more">+</button></div>' +
        '<button type="button" class="dc-bar-b"></button></div>';
      document.body.appendChild(bar);
      var tt = $('.dc-bar-t b', bar), pp = $('.dc-bar-t span', bar), bb = $('.dc-bar-b', bar), bq = $('.dc-bar-q input', bar);
      var title = $('#product-title');
      function sync() {
        tt.textContent = title ? title.textContent.trim() : '';
        var pr = $('#ProductPrice'); pp.textContent = pr ? pr.textContent.replace(/\s+/g, ' ').trim() : '';
        bb.textContent = (main.textContent || 'Buy now').replace(/\s+/g, ' ').trim();
        bb.disabled = main.disabled || main.classList.contains('disabled');
        bar.classList.toggle('dc-off', bb.disabled);
        if (qty && document.activeElement !== bq) bq.value = qty.value;
        if (qty && px && document.activeElement !== px) px.value = qty.value;
      }
      sync();
      var mo = new MutationObserver(sync);
      mo.observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
      var prEl = $('#ProductPrice'); if (prEl) mo.observe(prEl, { childList: true, subtree: true, characterData: true });
      if (qty) { qty.addEventListener('input', sync); qty.addEventListener('change', sync); }
      function setB(v) { v = Math.max(1, Math.min(99, parseInt(v, 10) || 1)); bq.value = v; if (qty) { qty.value = v; qty.dispatchEvent(new Event('change', { bubbles: true })); } }
      var sb = $$('.dc-step', bar);
      sb[0].addEventListener('click', function () { setB((parseInt(bq.value, 10) || 1) - 1); });
      sb[1].addEventListener('click', function () { setB((parseInt(bq.value, 10) || 1) + 1); });
      bq.addEventListener('change', function () { setB(bq.value); });
      bb.addEventListener('click', function () { if (!bb.disabled) { setB(bq.value); main.click(); } });
      var io = new IntersectionObserver(function (es) {
        var gone = !es[0].isIntersecting;
        bar.classList.toggle('dc-show', gone); document.body.classList.toggle('dc-has-bar', gone);
      }, { threshold: 0 });
      io.observe(main);
    }
  } catch (e) { if (window.console) console.warn('dc-product bar', e); }
})();